import PSEF from "../../assets/footer/PSEF-Logo.png";
import PermataBank from "../../assets/footer/PermataBank.png";
import Mandiri from "../../assets/footer/Mandiri.png";
import BNI from "../../assets/footer/BNI.png";
import BCA from "../../assets/footer/BCA.png";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getListCategory } from "../../services/purchaseApi";
import { readSafeStorage } from "../../utils/localStorageHelper";
import { getLabelConfig } from "../../config/labelConfig";

const Footer = () => {
  const label = getLabelConfig();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const outletName = readSafeStorage("outlet_name", "OLIN");
  const outletLogo = readSafeStorage("outlet_logo", label.logo);

  const { data: dataListCategory, isFetching: fetchingCategory } = useQuery({
    queryKey: ["category-list"],
    queryFn: () => getListCategory(),
    refetchOnWindowFocus: false,
  });

  const dynamicCategory = (dataListCategory ?? []).slice(0, 3).map((cat) => ({
    text: cat.name,
    path: `/purchase/category/${cat.id}`,
  }));

  const linkSections = [
    {
      title: "PINTASAN",
      links: [
        {
          text: "Riwayat Pesanan",
          path: "/purchase/transaction-list",
        },
        {
          text: "Keranjang Belanja",
          path: "/purchase/cart-details",
        },
        { text: "Konsultasi Dokter", path: "/consultation/detail-form" },
      ],
    },
    {
      title: "KATEGORI PRODUK",
      links: fetchingCategory
        ? [{ text: "Memuat...", path: "#" }]
        : dynamicCategory,
    },
    {
      title: "DAFTAR PRODUK",
      links: [
        { text: "Penawaran Spesial", path: "/" },
        { text: "Berdasarkan Pencarian", path: "/" },
        { text: "Paling Banyak Dicari", path: "/" },
      ],
    },
  ];

  return (
    <footer className="bg-white border-t border-gray-200 px-2 sm:px-4 md:px-8">
      <div className="max-w-7xl mx-auto px-2 lg:px-0">
        <div className="pt-8 pb-8 lg:pt-12 lg:pb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-12">
            <div className="lg:col-span-3">
              <div className="flex flex-col items-start mb-6">
                <div
                  className="flex items-end gap-2 mb-3 cursor-pointer h-10 max-w-[160px] w-auto shrink-0"
                  onClick={() => navigate("/")}
                >
                  <img
                    src={outletLogo}
                    className="h-full w-auto max-w-full object-contain"
                    alt="Outlet Logo"
                  />
                </div>
                <p className="text-sm md:text-md text-slate-600 max-w-xs leading-relaxed">
                  {outletName} adalah platform digital farmasi yang membantu
                  mengelola resep, pemesanan obat, dan layanan kesehatan dalam
                  satu sistem yang terintegrasi.
                </p>
              </div>
            </div>

            {linkSections.map((section, index) => (
              <div key={index} className="lg:col-span-1">
                <h3 className="font-semibold text-slate-800 mb-4 lg:mb-4 text-sm md:text-md uppercase tracking-wide">
                  {section.title}
                </h3>
                <ul className="space-y-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a
                        href={link.path}
                        className="flex items-center gap-3 text-slate-600 hover:text-primary transition-colors duration-300 group text-sm md:text-md"
                        target={
                          link.path.startsWith("http") ? "_blank" : "_self"
                        }
                        rel={
                          link.path.startsWith("http")
                            ? "noreferrer noopener"
                            : undefined
                        }
                      >
                        {link.icon && (
                          <link.icon
                            size={16}
                            className="text-slate-400 group-hover:text-primary transition-colors shrink-0"
                          />
                        )}
                        <span className="leading-relaxed">{link.text}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-gray-200 py-4 md:pt-2 md:pb-6">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <p className="text-sm md:text-md text-primary text-center md:text-left">
              Copyright {currentYear} ©{" "}
              <span className="font-semibold">OLIN Team</span> All Rights
              Reserved.
            </p>
            <div className="flex flex-col md:flex-row items-center md:items-end gap-3 md:gap-6">
              <div className="flex items-center justify-center gap-2 md:gap-3">
                <img src={BCA} alt="Bank BCA" className="w-14 md:w-16" />
                <img src={BNI} alt="Bank BNI" className="w-14 md:w-16" />
                <img
                  src={Mandiri}
                  alt="Bank Mandiri"
                  className="w-14 md:w-16"
                />
                <img
                  src={PermataBank}
                  alt="Bank Permata"
                  className="w-14 md:w-16"
                />
              </div>
              <div className="flex items-center gap-2">
                <img src={PSEF} alt="PSEF Logo" className="w-12 md:w-14" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
